import React, { Fragment, useEffect, useState, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import swal from "sweetalert";
import { useTranslation } from 'react-i18next';
import { Updatepassword, getPassword } from './store';
import { AesDecrypt } from '../../../services/crypto';
import { MD5 } from 'crypto-js';
import Swal from 'sweetalert2';

const Changepassword = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [oldpassword, setoldpassword] = useState("");
    const [Id, setId] = useState("");
    const [showCurrent, setShowCurrent] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [currentPassword, setCurrentPassword] = useState('');
    const [password1, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState({ currentPassword: '', password1: '', confirmPassword: '' });

    useEffect(() => {
        const id = localStorage.id;
        setId(id)
        if (id !== "undefined") {
            dispatch(getPassword(id)).then((res) => {
                const oldpw = AesDecrypt(res.payload.password)
                setoldpassword(oldpw)
            })
        }
    }, [dispatch])

    const handleCurrentPasswordChange = (e) => {
        setCurrentPassword(e.target.value);
        setErrors(prevErrors => ({ ...prevErrors, currentPassword: '' }));
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
        setErrors(prevErrors => ({ ...prevErrors, password1: '' }));
    };

    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
        setErrors(prevErrors => ({ ...prevErrors, confirmPassword: '' }));
    };


    const handleSubmit = (e) => {
        e.preventDefault();

        if (!currentPassword || !password1 || !confirmPassword) {
            setErrors({
                currentPassword: !currentPassword ? t('Current password is required') : '',
                password1: !password1 ? t('New password is required') : '',
                confirmPassword: !confirmPassword ? t('Confirm password is required') : ''
            });
            return;
        }

        if (password1.length < 6 || confirmPassword.length < 6) {
            setErrors({
                password1: password1.length < 6 ? t('Password contains minimum 6 digits') : '',
                confirmPassword: confirmPassword.length < 6 ? t('Password contains minimum 6 digits') : ''
            });
            return;
        }

        const Oldpassword = MD5(currentPassword).toString();
        const password = MD5(password1).toString();
        const Newpassword = MD5(confirmPassword).toString();
        const data = { password, Id };

        if (Oldpassword === oldpassword) { // Check if current password matches old password
            if (password === Newpassword) {
                dispatch(Updatepassword(data)).then((res) => {
                    const Response = res.payload.response;
                    if (Response === "S") {
                        Swal.fire({
                            title: t("Password Update Successful"),
                            icon: "success",
                        });
                        navigate('/dashboard');
                    }
                });
            } else {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    password1: t('Passwords do not match')
                }));
            }
        } else {
            setErrors((prevErrors) => ({
                ...prevErrors,
                currentPassword: t('Current password does not match')
            }));
        }

        if (password !== Newpassword) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                confirmPassword: t('Passwords do not match')
            }));
        }
    };



    return (
        <Fragment>
            <div className="card col-lg-6 container justify-content-center " style={{ boxShadow: "0px 0px 10px 10px rgb(144 144 144 / 56%)" }}>
                <div className="d-flex justify-content-center h-100 align-items-center">
                    <div className="row justify-content-center h-100 align-items-center">
                        <div className='icon_backButton' >
                            <Link to={"/dashboard"}>
                                <i className="fas fa-arrow-alt-circle-left"></i>
                            </Link>
                        </div>
                        <div className="row no-gutters">
                            <div className="col-xl-12 tab-content">
                                <div id="sign-in" className="form-validate">
                                    <form className="form-validate" onSubmit={handleSubmit}>
                                        <h3 className="text-center mb-4 text-black">{t('Update Password')}</h3>
                                        <div className="form-group mb-3">
                                            <label className="mb-1" htmlFor="val-password"><strong className='text-black'>{t('Current Password')}</strong></label>
                                            <div className="input-group" style={{ position: 'relative' }}>
                                                <input
                                                    onChange={handleCurrentPasswordChange}
                                                    value={currentPassword}
                                                    type={showCurrent ? "text" : "password"}
                                                    style={{ display: "block", width: "100%", border: "0px", borderBottom: "1px solid orange", padding: "5px", paddingRight: "30px", fontSize: "20px", outline: "none" }}
                                                />
                                                <span
                                                    style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}
                                                    onClick={() => setShowCurrent(!showCurrent)}
                                                >
                                                    <i className={`fa ${showCurrent ? 'fa-eye' : 'fa-eye-slash'}`} />
                                                </span>
                                            </div>
                                            {errors.currentPassword && <span style={{ color: 'red' }}>{errors.currentPassword}</span>}
                                        </div>
                                        <div className="form-group mb-3">
                                            <label className="mb-1"><strong className='text-black'>{t('New Password')}</strong></label>
                                            <div className="input-group" style={{ position: 'relative' }}>
                                                <input
                                                    onChange={handlePasswordChange}
                                                    value={password1}
                                                    type={showNew ? "text" : "password"}
                                                    style={{ display: "block", width: "100%", border: "0px", borderBottom: "1px solid orange", padding: "5px", paddingRight: "30px", fontSize: "20px", outline: "none" }}
                                                />
                                                <span
                                                    style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}
                                                    onClick={() => setShowNew(!showNew)}
                                                >
                                                    <i className={`fa ${showNew ? 'fa-eye' : 'fa-eye-slash'}`} />
                                                </span>
                                            </div>
                                            {errors.password1 && <span style={{ color: 'red' }}>{errors.password1}</span>}
                                        </div>
                                        <div className="form-group mb-3">
                                            <label className="mb-1"><strong className='text-black'>{t('Confirm Password')}</strong></label>
                                            <div className="input-group" style={{ position: 'relative' }}>
                                                <input
                                                    style={{ display: "block", width: "100%", border: "0px", borderBottom: "1px solid orange", padding: "5px", paddingRight: "30px", fontSize: "20px", outline: "none" }}
                                                    type={showConfirm ? "text" : "password"}
                                                    value={confirmPassword}
                                                    onChange={handleConfirmPasswordChange}
                                                />
                                                <span
                                                    style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}
                                                    onClick={() => setShowConfirm(!showConfirm)}
                                                >
                                                    <i className={`fa ${showConfirm ? 'fa-eye' : 'fa-eye-slash'}`} />
                                                </span>
                                            </div>
                                            {errors.confirmPassword && <span style={{ color: 'red' }}>{errors.confirmPassword}</span>}
                                        </div>

                                        <div className="text-center form-group mb-3" >
                                            {/* <button type="button" className="btn btn-secondary" style={{ marginRight: "5px" }} onClick={() => navigate('/dashboard')}>{t('Back')}</button> */}
                                            <button type="submit" className="btn btn-primary" >{t('Submit')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default Changepassword;
